import request from '@wearetla/tla-essentials-tools/utilities/request';
import { createI18nInstance } from '/utilities/i18n';

const getT = () => createI18nInstance().t;

const basketServices = {
	get: (items, branchSlug) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(
				'basket/prepare-product',
				{
					type: 'PRODUCT',
					products: items,
					branch_slug: branchSlug,
				},
				function (payload, status, request) {
					if (payload?.basket) {
						resolve(payload.basket);
					} else {
						reject(
							request?.data?.meta?.messages || t('Sepetin getirilirken bir hata ile karşılaşıldı.')
						);
					}
				}
			);
		});
	},
};

export default basketServices;
